import SitePermitCreationFormStore from '~/client/src/shared/components/SitePermitCreationForm/WorkflowCreationForm.store'
import WorkflowType from '~/client/src/shared/models/WorkflowType'

export default class PreviewPermitFormStore extends SitePermitCreationFormStore {
  public get permitTypes(): WorkflowType[] {
    return this.permitTypesStore.actualTypes
  }
}
